import { Form, FormControlProps, InputGroup, Input } from "rsuite";
import { forwardRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../core/redux/reduxStore";
import { ActionUI } from "../../../core/redux/slices/sliceUI";

type WithIconTextAreaFormInputProps = {
  showError?: boolean;
  errorText?: string;
  type?: string | undefined;
  svgicon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
} & FormControlProps;

const Textarea = forwardRef<HTMLTextAreaElement>((props, ref) => (
  <Input {...props} size="md" />
));

export const WithIconTextareaFormInput = ({
  type,
  name,
  className,
  ...props
}: WithIconTextAreaFormInputProps) => {
  const [errorVisible, setErrorVisible] = useState(false);
  const { userFormError } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();
  const errorStyles = (errorVisible: any, error: any) => {
    return {
      display: error || errorVisible ? "block" : "none",
      color: "red",
      marginTop: 6,
    };
  };
  return (
    <>
      <Form.Group as={InputGroup} className={`m-0 p-0 w-100` + className}>
        <Form.ControlLabel as={InputGroup.Addon} className="m-0">
          {props.svgicon && <props.svgicon />}
        </Form.ControlLabel>
        <Form.Control
          accepter={Textarea}
          id={name}
          className="textarea-form-input"
          name={name}
          type={type ? type : `text`}
          onBlur={(e: any) => {
            if (e.target.value === "") {
              setErrorVisible(true);
            }
          }}
          onFocus={() => {
            setErrorVisible(false);
            dispatch(
              ActionUI.setUserFormError({ ...userFormError, [name]: false })
            );
          }}
          {...props}
        />
        {/* {props.showError && props.errorText ? (
        <Form.ErrorMessage show={errorVisible || (userFormError as any)[name]} placement={"bottomStart"} style={{ left: "25px" }}>
          {props.errorText}
        </Form.ErrorMessage>
      ) : (
        <></>
      )} */}
      </Form.Group>
      {props.showError && props.errorText ? (
        <div style={errorStyles(errorVisible, (userFormError as any)[name])}>
          {props.errorText}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
